/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  PhoneInput,
  InputField,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { codeOk } from "../../../middlewares/index";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { getOneThingsToDo } from "../../../middlewares/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const thingsToDo = getOneThingsToDo();

  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  // ---- UI tokens: modern + consistent ----
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-2xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-4 sm:p-5";

  // ---- Messages / loading ----
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // ---- Core data ----
  const things_to_do_id = thingsToDo?.things_to_do_id;
  const [title, setTitle] = useState(thingsToDo?.title || "");
  const [thumbnail, setThumbnail] = useState(thingsToDo?.thumbnail || "");
  const [thumbnailId, setThumbnailId] = useState(
    thingsToDo?.image_cdn_id || ""
  );

  // ---- Contact & socials ----
  const [email, setEmail] = useState(thingsToDo?.email_address || "");
  const [payLink, setPayLink] = useState(thingsToDo?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState(
    thingsToDo?.phone_number || ""
  );
  const [whatsapp, setWhatsapp] = useState(thingsToDo?.whatsapp || "");
  const [facebook, setFacebook] = useState(thingsToDo?.facebook || "");
  const [twitter, setTwitter] = useState(thingsToDo?.twitter || "");
  const [instagram, setInstagram] = useState(thingsToDo?.instagram || "");
  const [youtube, setYoutube] = useState(thingsToDo?.youtube || "");
  const [hashtags, setHashtags] = useState(thingsToDo?.hashtag || "");

  // ---- Geo ----
  const [googleMapCode, setGoogleMapCode] = useState(
    thingsToDo?.google_map_code || ""
  );
  const [latitude, setLatitude] = useState(thingsToDo?.latitude || "");
  const [longitude, setLongitude] = useState(thingsToDo?.longitude || "");
  const [formattedAddress, setFormattedAddress] = useState(
    thingsToDo?.formatted_address || ""
  );

  // ---- Flags ----
  const [featured, setFeatured] = useState(thingsToDo?.featured ?? "no");
  const [promoted, setPromoted] = useState(
    thingsToDo?.promoted ? thingsToDo?.promoted : "no"
  );
  const [thingsToDoStatus, setThingsToDoStatus] = useState(
    thingsToDo?.status ?? 1
  );
  const [expo, setExpo] = useState(thingsToDo?.expo ?? 0);

  // ---- Content ----
  const [description, setDescription] = useState(thingsToDo?.description || "");
  const [pricing, setPricing] = useState(thingsToDo?.Pricings || []);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const thingsToDoRoutes = "/data/things/todo";

  // ---- Helpers ----
  const responses = (isError, msg) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const handleText = (setter) => (e) => {
    setter(e.target.value);
    setError(false);
    setSuccess(false);
  };

  const safeSlug = (t) =>
    t ? t.toLowerCase().trim().replace(/\s+/g, "_") : null;

  const updateOneThingsToDoHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) return responses(true, "Image Required");
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : thingsToDo?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,

      title,
      slug: safeSlug(title),
      description,

      thumbnail: thumbnail || defaultImage,
      image_cdn_id: thumbnailId || "",

      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,

      whatsapp,
      facebook,
      twitter,
      instagram,
      youtube,
      hashtag: hashtags,

      audio_adv: "none",

      google_map_code: googleMapCode,
      latitude,
      longitude,
      formatted_address: formattedAddress,
      country_short: "none",

      status: thingsToDoStatus,
      featured,
      promoted,
      expo,

      pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: things_to_do_id,
      data,
      content: _TYPES_.THINGSTODO,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className={`${container} py-4 lg:py-6`}>
        {/* Top Bar */}
        <div className="mb-3">
          <BreadCrumbComponent />
        </div>
        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: thingsToDoRoutes }} />
        </div>
        <div className="mb-4">
          <DashboardIntro
            props={{ intro: `Edit Things To Do`, name: entry_label }}
          />
        </div>

        {/* Feedback */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />
        </div>

        {/* Form */}
        <form onSubmit={updateOneThingsToDoHandler} className="space-y-4">
          {/* Media */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Cover Image" }} />
            <div className="mt-3">
              <ImageKitUpload
                thumbnail={thumbnail}
                thumbnailId={thumbnailId}
                setThumbnail={setThumbnail}
                setThumbnailId={setThumbnailId}
                folder={image_kit_folder(country_name, FOLDERS.THINGS_TO_DO)}
              />
            </div>
          </div>

          {/* Details */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Things To Do Details" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-3">
              <InputField
                props={{
                  id: "title",
                  title: "Title",
                  type: "text",
                  value: title,
                  onChange: handleText(setTitle),
                }}
              />
              <InputField
                props={{
                  id: "formatted_address",
                  title: "Formatted Address",
                  type: "address",
                  value: formattedAddress,
                  onChange: handleText(setFormattedAddress),
                }}
              />
            </div>
          </div>

          {/* Pricing */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Pricing" }} />
            <div className="mt-3">
              <Pricing pricing={pricing} setPricing={setPricing} />
            </div>
          </div>

          {/* Contact */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Contact Info" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-3">
              <div className="flex flex-row justify-center items-center">
                <PhoneInput
                  setPhone={setPhoneNumber}
                  phone={phoneNumber}
                  required={false}
                />
              </div>
              <InputField
                props={{
                  id: "email",
                  title: "Email Address",
                  type: "email",
                  value: email,
                  onChange: handleText(setEmail),
                }}
              />
              <InputField
                props={{
                  id: "pay-link",
                  title: "Pay Link (Optional)",
                  type: "text",
                  value: payLink ? payLink : null,
                  onChange: (e) => {
                    setPayLink(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </div>

          {/* Social */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Social Contact" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mt-3">
              <InputField
                props={{
                  id: "whatsapp",
                  title: "Whatsapp",
                  type: "text",
                  value: whatsapp,
                  onChange: handleText(setWhatsapp),
                }}
              />
              <InputField
                props={{
                  id: "facebook",
                  title: "Facebook",
                  type: "text",
                  value: facebook,
                  onChange: handleText(setFacebook),
                }}
              />
              <InputField
                props={{
                  id: "twitter",
                  title: "Twitter",
                  type: "text",
                  value: twitter,
                  onChange: handleText(setTwitter),
                }}
              />
              <InputField
                props={{
                  id: "instagram",
                  title: "Instagram",
                  type: "text",
                  value: instagram,
                  onChange: handleText(setInstagram),
                }}
              />
              <InputField
                props={{
                  id: "youtube",
                  title: "YouTube",
                  type: "text",
                  value: youtube,
                  onChange: handleText(setYoutube),
                }}
              />
            </div>
          </div>

          {/* Geo */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "Geo Position" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mt-3">
              <InputField
                props={{
                  id: "google_map_code",
                  title: "Google Map Code",
                  type: "text",
                  value: googleMapCode,
                  onChange: handleText(setGoogleMapCode),
                }}
              />
              <InputField
                props={{
                  id: "latitude",
                  title: "Latitude",
                  type: "text",
                  value: latitude,
                  onChange: handleText(setLatitude),
                }}
              />
              <InputField
                props={{
                  id: "longitude",
                  title: "Longitude",
                  type: "text",
                  value: longitude,
                  onChange: handleText(setLongitude),
                }}
              />
            </div>
          </div>

          {/* More settings */}
          <div className={`${card} ${sectionPad}`}>
            <Title props={{ title: "More Settings" }} />
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-3">
              <Select
                props={{
                  id: "thingsToDo_status",
                  title: "Status",
                  option: ["visible", "invisible"],
                  preselect:
                    thingsToDoStatus !== null
                      ? [
                          {
                            name:
                              thingsToDoStatus === 1 ? "visible" : "invisible",
                          },
                        ]
                      : null,
                  onChange: (e) => {
                    setThingsToDoStatus(e.target.selectedIndex === 0 ? 1 : 0);
                    setError(false);
                    setSuccess(false);
                  },
                }}
              />
              <Select
                props={{
                  id: "featured",
                  title: "Featured",
                  option: ["no", "yes"],
                  preselect: featured !== null ? [{ name: featured }] : null,
                  onChange: (e) => {
                    setFeatured(e.target.value);
                    setError(false);
                    setSuccess(false);
                  },
                }}
              />
              <Select
                props={{
                  id: "promoted",
                  title: "Promoted",
                  option: ["no", "yes"],
                  preselect: promoted !== null ? [{ name: promoted }] : null,
                  onChange: (e) => {
                    setPromoted(e.target.value);
                    setError(false);
                    setSuccess(false);
                  },
                }}
              />
              <Select
                props={{
                  id: "gallery",
                  title: "Show in Gallery",
                  option: ["no", "yes"],
                  preselect:
                    expo !== null
                      ? [{ name: expo === 0 ? "no" : "yes" }]
                      : null,
                  onChange: (e) => {
                    setExpo(e.target.value === "no" ? 0 : 1);
                    setError(false);
                    setSuccess(false);
                  },
                }}
              />
            </div>
          </div>

          {/* Description */}
          <div className={`${card} ${sectionPad}`}>
            <div className="flex flex-col gap-3">
              <div>
                <MyButton
                  onClick={() => setShowDescriptionModal(true)}
                  className="bg-blue-700 py-3"
                >
                  Generate Description
                </MyButton>
              </div>
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description,
                  onChange: handleText(setDescription),
                }}
              />
            </div>
          </div>

          {/* Tags + Submit */}
          <div className={`${card} ${sectionPad}`}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <InputField
                props={{
                  id: "hashtag",
                  title: "Tags (comma separated)",
                  type: "text",
                  value: hashtags,
                  onChange: handleText(setHashtags),
                }}
              />
            </div>
            <div className="pt-4">
              <MyActionButton
                loading={loading}
                title="Save Changes"
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </form>
      </div>

      {/* Description modal */}
      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={setDescription}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}
    </div>
  );
};

export default Edit;
